import { useState } from 'react'
import {
  Button,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  InputProps,
  TextField,
  Typography
} from '@mui/material'
import valueMask from '@/utils/masks/value'
import CustomView from './CustomView'
import styled from 'styled-components'
import { makeStyles } from '@mui/styles'

import LockIcon from '@mui/icons-material/Lock'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

const useStyles = makeStyles({
  number: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
})

const CustomTexField = styled(TextField)`
  & label.Mui-focused {
    color: #142954;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #142954;
    }
  }
  .MuiInputBase-input.Mui-disabled,
  .MuiInputBase-adornedEnd.Mui-disabled,
  .MuiInputBase-multiline.Mui-disabled {
    background-color: #f8f8fa;
  }
`

interface FormInputProps extends InputProps {
  pl?: any
  pr?: any
  id?: string
  mb?: string
  isCurrency?: boolean
  customStyle?: string
  helperText?: string
  labelName?: string
  onChange?: any
  onKeyDown?: any
  errorMessage?: any
  width?: string
  mask:
    | 'CPF'
    | 'CNPJ'
    | 'WithoutMask'
    | 'PhoneNumber'
    | 'CEP'
    | 'Number'
    | 'StateRegistration'
    | 'file'
    | 'Plate'
  value?: any
}

function FormInput({
  id,
  pr,
  pl,
  mb,
  width = '100%',
  mask,
  name,
  value,
  labelName,
  customStyle,
  errorMessage,
  type,
  isCurrency = false,
  endAdornment,
  ...rest
}: FormInputProps) {
  const [showPassword, setShowPassword] = useState(false)
  const classes = useStyles()

  const maskedValue = () => {
    return valueMask({ mask, value })
  }

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState)
  }

  // this function return the style of input, we have two of it for now, you can also include new styles here.
  function getInputStyle() {
    switch (customStyle) {
      case 'file':
        return (
          <FormControl>
            <Button
              component="label"
              size="large"
              variant="text"
              style={{ marginTop: '123px' }}
            >
              <CustomTexField
                error={errorMessage ? true : false} //typescript error, this doesnt support only errorMessage to take boolean value;
                helperText={errorMessage ? '' : rest.helperText}
                id={id}
                disabled={rest.disabled}
                name={name}
                label={labelName}
                value={maskedValue() || ''}
                onChange={rest.onChange}
                FormHelperTextProps={{
                  style: {
                    fontSize: '12px'
                  }
                }}
                type={type}
                InputProps={{
                  startAdornment: isCurrency ? (
                    <InputAdornment
                      style={{ fontSize: '16px' }}
                      position="start"
                    >
                      R$
                    </InputAdornment>
                  ) : (
                    ''
                  ),
                  endAdornment: endAdornment,
                  style: {
                    fontSize: '14px'
                  }
                }}
                inputProps={{
                  maxLength:
                    mask === 'CEP' ? 9 : mask === 'PhoneNumber' ? 15 : ''
                }}
                InputLabelProps={{
                  style: {
                    fontSize: '14px'
                  }
                }}
              />
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={() => console.log('aqui')}
              />
            </Button>
          </FormControl>
        )
      case 'withBorder':
        return (
          <FormControl>
            <CustomTexField
              error={errorMessage ? true : false} //typescript error, this doesnt support only errorMessage to take boolean value;
              helperText={errorMessage ? '' : rest.helperText}
              id={id}
              disabled={rest.disabled}
              placeholder={rest.placeholder}
              name={name}
              label={labelName}
              value={maskedValue() || ''}
              onChange={rest.onChange}
              onKeyDown={rest.onKeyDown}
              FormHelperTextProps={{
                style: {
                  fontSize: '12px'
                }
              }}
              multiline={rest.multiline}
              rows={rest.rows}
              type={type}
              InputProps={{
                startAdornment: isCurrency ? (
                  <InputAdornment style={{ fontSize: '16px' }} position="start">
                    R$
                  </InputAdornment>
                ) : (
                  ''
                ),
                endAdornment: endAdornment,
                style: {
                  fontSize: '14px'
                }
              }}
              inputProps={{
                maxLength:
                  mask === 'CEP'
                    ? 9
                    : mask === 'PhoneNumber'
                    ? 15
                    : mask === 'Plate'
                    ? 7
                    : ''
              }}
              InputLabelProps={{
                style: {
                  fontSize: '14px'
                }
              }}
            />
          </FormControl>
        )
      case 'isPercent':
        return (
          <FormControl style={{ maxWidth: '115px' }}>
            <TextField
              error={errorMessage ? true : false} //typescript error, this doesnt support only errorMessage to take boolean value;
              helperText={errorMessage ? '' : rest.helperText}
              id={id}
              disabled={rest.disabled}
              variant="standard"
              name={name}
              label={labelName}
              value={maskedValue() || ''}
              onChange={rest.onChange}
              className={classes.number}
              FormHelperTextProps={{
                style: {
                  fontSize: '12px'
                }
              }}
              type={type}
              InputProps={{
                endAdornment: '%',
                style: {
                  fontSize: '28px'
                }
              }}
              inputProps={{
                style: { textAlign: 'center' },
                step: 0.01,
                maxLength: 5
              }}
              InputLabelProps={{
                style: {
                  fontSize: '28px'
                }
              }}
            />
          </FormControl>
        )
      case 'percentSmall':
        return (
          <FormControl style={{ maxWidth: '90px' }}>
            <TextField
              variant="outlined"
              size="small"
              value={maskedValue() || ''}
              className={classes.number}
              type={type}
              disabled={rest.disabled}
              onChange={rest.onChange}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F5F5F5',
                  borderRadius: '5px'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc'
                }
              }}
              InputProps={{
                endAdornment: '%',
                style: {
                  fontSize: '14px',
                  height: '32px'
                }
              }}
              inputProps={{
                style: {
                  textAlign: 'center'
                },
                step: 0.01
              }}
            />
          </FormControl>
        )
      default:
        return (
          <FormControl variant="standard" fullWidth>
            <InputLabel
              htmlFor={id}
              style={{
                color: '#142954',
                fontSize: '16px',
                fontWeight: 'bold',
                transform: 'unset !important',
                WebkitTransform: 'unset'
              }}
            >
              {labelName}
            </InputLabel>
            <Input
              id={id}
              value={maskedValue()}
              style={{ marginTop: '37px', fontSize: '16px' }}
              type={showPassword ? 'text' : type}
              startAdornment={
                type === 'password' ? (
                  <InputAdornment position="start">
                    <LockIcon fontSize="large" />
                  </InputAdornment>
                ) : (
                  rest.startAdornment
                )
              }
              endAdornment={
                type === 'password' && value ? (
                  <InputAdornment position="end">
                    {showPassword ? (
                      <VisibilityOffIcon
                        fontSize="large"
                        onClick={handleShowPassword}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      <Visibility
                        fontSize="large"
                        onClick={handleShowPassword}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </InputAdornment>
                ) : (
                  endAdornment
                )
              }
              {...rest}
            />
          </FormControl>
        )
    }
  }

  return (
    <CustomView pr={pr} pl={pl} mb={mb} width={width}>
      {getInputStyle()}
      <Typography fontSize="12px" color="red" mt="2px">
        {errorMessage}
      </Typography>
    </CustomView>
  )
}

export default FormInput
